module.exports = __webpack_public_path__ + "img/shanghaigongchengLogo.10e436c9.png";